export const notificationCardStyles = {
  notificationCardWrapper: {
    display: "flex",
    flexDirection: "column",
    padding: "0.8rem 1.2rem 1.2rem 1.2rem",
    cursor: "pointer",
    borderRadius: "1.1rem",
    backgroundColor: "var(--neutral-100)",
    margin: "0rem 2rem 1rem 2rem",
  },
  notificationContent: {
    display: "flex",
    flexDirection: "column",
    gap: "0.4rem",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    padding: "0.6rem",
    backgroundColor: "var(--soft-peach)",
    borderRadius: "100%",
  },
  notificationTitle: {
    fontSize: "1.4rem",
    fontWeight: 500,
    color: "var(--dark-gray)",
    lineHeight: "2rem",
  },
  notificationDescription: {
    fontSize: "1.4rem",
    fontWeight: 400,
    color: "var(--gray-600)",
    lineHeight: "2rem",
  },
  notificationTime: {
    fontSize: "1.3rem",
    fontWeight: 400,
    lineHeight: "1.6rem",
    color: "var(--gray-1000)",
    marginTop: "0.8rem",
    alignSelf: "flex-end",
  },
};
